import { collection, doc, getDoc, onSnapshot, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { store } from '../../../config/firebase';
import { liveGameDocs } from '../../../helpers/games';
import GameByStatusCards from '../../ui/gameStatusCards/gameByStatusCards';
import { Box, Input, Stack, Typography } from '@mui/material';
import BSCircularProgress from '../../ui/progress/circularProgress';

const EmbeddedActiveGames = ({ event: eventId }) => {
  const [loading, setLoading] = useState();
  const [games, setGames] = useState([]);
  const [filterInput, setFilterInput] = useState('');
  const [filteredGames, setFilteredGames] = useState([]);

  useEffect(() => {
    if (!eventId) {
      setGames([]);
      setFilteredGames([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setGames([]);
    const collectionRef = collection(store, 'games');
    const eventRef = doc(store, 'events', eventId);
    const q = query(
      collectionRef,
      where('updatedAt', '>=', new Date(Date.now() - 30 * 60000)),
      where('event', 'in', [eventId, eventRef])
    );

    const unsubscribe = onSnapshot(
      q,
      async (querySnapshot) => {
        const gamesData = await Promise.all(
          liveGameDocs(querySnapshot).map(async (docSnap) => {
            const gameData = { id: docSnap.id, ...docSnap.data() };
            // Load venue details if venue is an ID
            if (gameData.venue && typeof gameData.venue === 'string') {
              try {
                const venueDoc = await getDoc(doc(store, 'venues', gameData.venue));
                if (venueDoc.exists()) {
                  gameData.venue = { id: venueDoc.id, ...venueDoc.data() };
                }
              } catch (e) {
                // Handle error or leave venue as ID
              }
            }
            return gameData;
          })
        );

        gamesData.sort((a, b) => {
          const aKey = `${a.green}${a.rink}`;
          const bKey = `${b.green}${b.rink}`;
          return aKey.localeCompare(bKey, undefined, { numeric: true });
        });

        setGames(gamesData);
        setFilteredGames(gamesData);
        setLoading(false);
      },
      () => {
        setGames([]);
        setFilteredGames([]);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [eventId]);

  // Get Event from firbase
  const [event, setEvent] = useState(null);
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const eventDoc = await getDoc(doc(store, 'events', eventId));
        if (eventDoc.exists()) {
          setEvent({ id: eventDoc.id, ...eventDoc.data() });
        }
      } catch (e) {
        // Handle error
      }
    };
    fetchEvent();
  }, [eventId]);

  useEffect(() => {
    let filteredByRound = games;

    // Filter by current round if event uses publish-rounds method
    if (event?.roundPublishMethod === 'publish-rounds') {
      filteredByRound = games.filter((game) => event.currentRound === game.round);
    }

    if (filterInput === '') {
      setFilteredGames(filteredByRound);
    } else {
      setFilteredGames(
        filteredByRound.filter((game) => {
          const teamA = game.teams.teamA.players.join(' ').toLowerCase();
          const teamB = game.teams.teamB.players.join(' ').toLowerCase();
          return (
            teamA.includes(filterInput.toLowerCase()) || teamB.includes(filterInput.toLowerCase())
          );
        })
      );
    }
  }, [filterInput, games, eventId, event]);

  //   const teamName = team.players
  //     .map((player) => {
  //       if (team.players.length > 2) {
  //         return player.split(' ')[0].charAt(0) + '. ' + player.split(' ')[1];
  //       } else {
  //         return player;
  //       }
  //     })
  //     .join(', ');

  return (
    <Stack gap={2}>
      <Input
        name="filter"
        label="Filter"
        placeholder="Filter by Surname"
        sx={{ textAlignLast: 'center', textAlign: 'center' }}
        value={filterInput}
        onChange={(e) => setFilterInput(e.target.value)}
      />

      <Box display={'flex'} flexDirection={'row'} p={1} flexWrap={'wrap'} gap={2}>
        {loading ? (
          <BSCircularProgress caption={'Loading Games'} />
        ) : filteredGames.length !== 0 ? (
          filteredGames.map((game) => (
            <GameByStatusCards key={game.id} game={game} actions={false} showSectionWinners />
          ))
        ) : (
          <Box>
            <Typography variant="caption">
              There are currently no active games being scored. (In the last 30 min)
            </Typography>
          </Box>
        )}
      </Box>
    </Stack>
  );
};

export default EmbeddedActiveGames;
